import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {RegisterButtonDefaultBox} from "./register-button.default.box";
import {RegisterButtonSiBox} from "./register-button.si.box";
import {RegisterButtonMrGreenBox} from "./register-button.mrgreen.box";

export const RegisterButtonBox = styledByTheme(RegisterButtonDefaultBox)
    .forSI(RegisterButtonSiBox)
    .forMrGreen(RegisterButtonMrGreenBox)
    .apply();